export default __webpack_public_path__ + "static/media/1.cfb915ae.png";